import {
  FieldDefinition,
  FieldBuilder,
  MenuCategories,
  MenuSubcategories,
  MENU_CATEGORY_KEY,
  MENU_SUBCATEGORY_KEY,
  MENU_NAME_SUFFIX,
  PERIOD_TYPE_NAME_PLANNED_PLANNING_SEASON,
} from '@zendra/shared';
import {
  LocationService,
  PeriodService,
  PropertyTypeService,
  ReasonService,
  RegionService,
  ZoneService,
} from 'cbd-proxies';
import { PipelineStand } from '../pipeline-stand/pipeline-stand';

FieldBuilder.setNamespace('Operational');

export const PIPELINEPROPERTY_FIELDS: FieldDefinition[] = [
  FieldBuilder.text('name', 'Entity.PipelineProperty.Name')
    .required()
    .maxLength(100)
    .build(),
  FieldBuilder.foreignKey('zoneId', 'Entity.Zone', ZoneService)
    .required()
    .display('name')
    .displayFromNested('zoneName')
    .sortBy('zoneName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey('regionId', 'Entity.Region', RegionService)
    .display('name')
    .displayFromNested('regionName')
    .sortBy('regionName')
    .readOnly()
    .build(),
  FieldBuilder.foreignKey(
    'propertyTypeId',
    'Entity.PipelineProperty',
    PropertyTypeService,
  )
    .required()
    .display('name')
    .displayFromNested('propertyTypeName')
    .sortBy('propertyTypeName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey('periodId', 'Entity.Period', PeriodService)
    .required()
    .queryFilter({ periodTypeName: PERIOD_TYPE_NAME_PLANNED_PLANNING_SEASON })
    .display('name')
    .displayFromNested('periodName')
    .sortBy('periodName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'signatureReasonId',
    'Entity.PipelineProperty.SignatureReason',
    ReasonService,
  )
    .required()
    .queryFilter({ reasonGroupName: 'Status Firma' })
    .display('name')
    .displayFromNested('signatureReasonName')
    .sortBy('signatureReasonName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'dinamaReasonId',
    'Entity.PipelineProperty.DinamaReason',
    ReasonService,
  )
    .required()
    .queryFilter({ reasonGroupName: 'Status Dinama' })
    .display('name')
    .displayFromNested('dinamaReasonName')
    .sortBy('dinamaReasonName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'millLocationId',
    'Entity.PipelineProperty.MillLocation',
    LocationService,
  )
    .queryFilter({ isDestination: true })
    .display('name')
    .keyField('id')
    .readOnly()
    .build(),
  FieldBuilder.number('distanceToMill', 'Entity.PipelineProperty.DistanceToMill')
    .decimal()
    .readOnly()
    .build(),
];

export const PIPELINEPROPERTY_CONFIG = {
  entityName: 'PipelineProperty',
  localizationKey: 'Operational::Entity.PipelineProperty',
  fields: PIPELINEPROPERTY_FIELDS,
  permission: 'PlanningOperation.PipelineProperties',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.PlanningOperational + MENU_NAME_SUFFIX,
  menuSubcategory:
    MENU_SUBCATEGORY_KEY + MenuSubcategories.Silviculture + MENU_NAME_SUFFIX,
  children: [
    {
      entityName: 'PipelineStand',
      foreignKeyField: 'pipelinePropertyId',
      localizationKey: 'Operational::Entity.PipelineStand',
      component: PipelineStand,
    },
  ],
};
